import { Search } from '@carbon/icons-react';
import { useTranslation } from 'react-i18next';
import { ErrorState, ForbiddenState, OfflineState, StateLayout } from '@/ui';
import { useHelp } from '../shell/HelpContext';
import { describeError } from './errors';

export interface QueryErrorStateProps {
  error: unknown;
  onRetry?: () => void;
  retrying?: boolean;
  compact?: boolean;
  headingLevel?: 2 | 3;
}

/**
 * Состояние ошибки для экрана или блока с данными: нет сети, нет прав, не найдено,
 * лимит запросов, сервис недоступен — каждое со своим объяснением и действием (ТЗ 14.3).
 */
export function QueryErrorState({ error, onRetry, retrying, compact, headingLevel }: QueryErrorStateProps) {
  const { t, i18n } = useTranslation('errors');
  const help = useHelp();
  const info = describeError(error, t, i18n);
  if (info.kind === 'network') return <OfflineState onRetry={onRetry} compact={compact} headingLevel={headingLevel} />;
  if (info.kind === 'forbidden') return <ForbiddenState compact={compact} headingLevel={headingLevel} description={info.description} />;
  if (info.kind === 'notFound') {
    return <StateLayout icon={Search} compact={compact} headingLevel={headingLevel} title={info.title} description={info.description} />;
  }
  return (
    <ErrorState
      title={info.title}
      description={info.description}
      requestId={info.requestId}
      onRetry={onRetry}
      retrying={retrying}
      compact={compact}
      headingLevel={headingLevel}
      onContactSupport={() => help.open({ requestId: info.requestId, errorCode: info.code })}
    />
  );
}
